b-colb-col
<template>
  <div>
    <header-title
      title="المنظمات بالأرقام"
      titlePrevious="الرئيسية"
      color="#ea5455"
    />
    <div class="wrapper container">
      <div class="main-content p-2">
        <div>
          <div class="filter_small_screen">
            <collapse-header title_img="filter" title="بحث بحسب">
              <b-form-row class="">
                <b-col>
                  <form-select
                    label="التصنيف"
                    v-model="filterForm.ngo_classification_id"
                    :getOptionLabel="(x) => x.name_ar"
                    :reduce="(x) => x.id"
                    id="classifications"
                    ep="v2/guest/selects/classifications"
                  />
                </b-col>
                <b-col>
                  <form-select
                    label="المحافظة"
                    v-model="filterForm.governorate_id"
                    :getOptionLabel="(x) => x.name_ar"
                    :reduce="(x) => x.id"
                    id="statistics_governorate"
                    ep="v2/guest/selects/governorates"
                  />
                </b-col>
                <b-col>
                  <form-select
                    label="الشكل القانوني"
                    v-model="filterForm.legal_form"
                    :getOptionLabel="(x) => x.name_ar"
                    :reduce="(x) => x.id"
                    id="legal-form"
                    ep="v2/guest/selects/legal-forms"
                  />
                </b-col>
              </b-form-row>
              <div class="px-1 d-flex justify-content-between">
                <b-button variant="info" class="mx-1" @click="fliterByParam()"
                  >بحث</b-button
                >
                <b-button variant="primary" @click="unFilter()"
                  >إلغاء البحث</b-button
                >
              </div>
            </collapse-header>
          </div>
        </div>
        <div class="sidebar">
          <div
            class="d-flex small_header p-2 m-auto justify-content-between align-items-center bg-white shadow"
          >
            <b-form-row class="d-flex w-100 align-items-center flex-wrap">
              <b-col>
                <form-select
                  class="w-25"
                  label="التصنيف"
                  v-model="filterForm.ngo_classification_id"
                  :getOptionLabel="(x) => x.name_ar"
                  :reduce="(x) => x.id"
                  id="classifications"
                  ep="v2/guest/selects/classifications"
                />
              </b-col>
              <b-col>
                <form-select
                  class="w-25 mx-25"
                  label="المحافظة"
                  v-model="filterForm.ngo_classification_id"
                  :getOptionLabel="(x) => x.name_ar"
                  :reduce="(x) => x.id"
                  id="statistics_governorate"
                  ep="v2/guest/selects/governorates"
                />
              </b-col>
              <b-col>
                <form-select
                  class="w-25"
                  label="الشكل القانوني"
                  v-model="filterForm.ngo_classification_id"
                  :getOptionLabel="(x) => x.name_ar"
                  :reduce="(x) => x.id"
                  id="legal-form"
                  ep="v2/guest/selects/legal-forms"
                />
              </b-col>
            </b-form-row>
            <div class="px-1 d-flex justify-content-end" style="width: 300px">
              <loader-btn
                variant="info"
                class="mx-1"
                @click="fliterByParam()"
                label="بحث"
                loadingLabel="جاري البحث ..."
                noIcon
              />
              <b-button variant="primary" @click="unFilter()"
                >إلغاء البحث</b-button
              >
            </div>
          </div>
        </div>

        <div class="top-container d-flex werap my-4">
          <b-card body-class="pb-50 bg-white">
            <h4 class="my-1">عدد المنظمات الكلي</h4>
            <h3 class="mb-1 text-danger">2,616</h3>
          </b-card>
          <b-card body-class="pb-50">
            <h4 class="my-1">عدد المنظمات الفاعلة</h4>
            <h3 class="mb-1 text-danger">1,379</h3>
          </b-card>
          <b-card body-class="pb-50">
            <h4 class="my-1">نسبة المنظمات الفاعلة</h4>
            <h3 class="mb-1 text-danger">60%</h3>
          </b-card>
        </div>
        <b-card class="my-4">
          <h4>نسب المنظمات حسب شكلها القانوني</h4>
          <hr />
          <div class="d-flex justify-content-center">
            <vue-apex-charts
              type="pie"
              width="500"
              :options="pie.chartOptions"
              :series="pie.series"
            ></vue-apex-charts>
          </div>
        </b-card>
        <b-card>
          <h4>توزع المنظمات حسب المحافظات</h4>
          <hr />
          <div>
            <vue-apex-charts
              type="bar"
              height="350"
              :options="bar.chartOptions"
              :series="bar.series"
            ></vue-apex-charts>
          </div>
          <h6 class="text-center">إحصائية بين عامي 2019 و 2022</h6>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { BCard, BCol, BRow, BFormRow, BButton } from "bootstrap-vue";
import formSelect from "@/components/form-select";
import loaderBtn from "@/components/loader-btn";

import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";
import HeaderTitle from "../../components/HeaderTitle.vue";
import CollapseHeader from "@core/components/app-collapse/CollapseHeader.vue";

export default {
  components: {
    BCard,
    BCol,
    BRow,
    BFormRow,
    VueApexCharts,
    formSelect,
    HeaderTitle,
    CollapseHeader,
    BButton,
    loaderBtn,
  },
  data() {
    return {
      filterForm: {},
      pie: {
        series: [1180, 136, 23, 2, 31, 7],
        chartOptions: {
          chart: {
            width: 380,
            type: "pie",
          },
          labels: ["جمعية", "مؤسسة", "رابطة", "إتحاد", "نادي", "فرع مشهر"],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      },
      bar: {
        series: [
          {
            name: "المنظمات الفاعلة",
            data: [397, 120, 101, 85, 97, 100, 22, 19, 3, 15, 5, 246, 127, 42],
            color: $themeColors.primary,
          },
          {
            name: "عدد المنظمات في المحافظة",
            data: [528, 162, 164, 169, 86, 74, 18, 15, 23, 6, 10, 211, 177, 49],
            color: $themeColors.info,
          },
        ],
        chartOptions: {
          chart: {
            type: "bar",
            height: 350,
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          xaxis: {
            categories: [
              "دمشق",
              "طرطوس",
              "اللاذقية",
              "حمص",
              "السويداء",
              "حماة",
              "القنيطرة",
              "درعا",
              "ادلب",
              "دير الزور",
              "الرقة",
              "ريف دمشق",
              "حلب",
              "الحسكة",
            ],
          },

          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val;
              },
            },
          },
        },
      },
    };
  },
};
</script>

<style>
.apexcharts-legend-series {
  display: flex;
  align-items: center;
  gap: 5px;
}
.apexcharts-legend-text,
.apexcharts-text {
  -webkit-font-family: "Cairo", sans-serif !important;
  -o-font-family: "Cairo", sans-serif !important;
  font-family: "Cairo", sans-serif !important;
}

.top-container {
  display: flex;
  background-color: transparent;
  width: 100%;
  justify-content: space-evenly;
}
@media (min-width: 300px) {
  .sidebar {
    display: none;
  }
  .filter_small_screen {
    display: block;
  }
}
@media (min-width: 1030px) {
  .sidebar {
    display: block;
  }
  .filter_small_screen {
    display: none;
  }
}
</style>
